module.exports = __webpack_public_path__ + "media/sounds/button-21b7d99f6416b4dc289a5680c0e828b5.wav";